const txt = "I learned piano when I was 5 years old. I particularly enjoy playing blues, jazz and pop music and I still often spend several hours per week playing the piano to relax!";

export default txt;
